import { DatePipe } from "@angular/common";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { BrowserModule } from "@angular/platform-browser";
import { AppRoutingModule } from "./app-routing.module";
import { OwsClientService } from "ows-library";
import { GlobalService } from "./compartilhado/servicos/global.service";
import { PopUpService } from "./compartilhado/componentes/pop-up/pop-up.service";
import { AuthGuard } from "./auth-guard.service";
import { AutenticacaoService } from "./compartilhado/servicos/autenticacao.service";
import { PopUpAlertaComponent } from "./compartilhado/componentes/pop-up/pop-up-alerta/pop-up-alerta.component";
import { AppComponent } from "./app.component";
import { RequestsService } from "./compartilhado/servicos/requests.service";
import { SelectivePreloadingStrategy } from "./selective-preloading-strategy";
import { LoaderService } from "./compartilhado/componentes/loader-interceptor/loader-interceptor.service";
import { PageTopComponent } from "./compartilhado/componentes/page-top/page-top.component";
import { CompartilhadoModule } from "./compartilhado/compartilhado.module";
import { RECAPTCHA_SETTINGS, RecaptchaSettings } from "ng-recaptcha";
import { AppConfigService } from "./app-config.service";
import { ScrollEventModule } from "ngx-scroll-event";
import { InterceptorService } from "./interceptor-service";
import { SessionService } from "./compartilhado/servicos/session.service";
import { AppConfigProvider } from "../app-config.service.provider";
import { LocalStorageModule } from "angular-2-local-storage";
import { CoreModule } from "./compartilhado/core/core.module";
import { AgendamentoService } from "./agendamento-vistorias/agendamento-form/agendamento.service";
import { AgendamentoMTService } from "./agendamento-vistorias/agendamento-mt-form/agendamento-mt.service";

import { VisualizarImagemOriginalService } from "./laudos-pa/visualizar-imagem-original/visualizar-imagem-original.service";
import { DxDateBoxModule, DxSelectBoxModule } from "devextreme-angular";
import { NgxMaskModule } from "ngx-mask";
import { PagamentoService } from "./compartilhado/componentes/pagamento-form/pagamento.service";
import { PaginaNaoEncontradaComponent } from "./pagina-nao-encontrada/pagina-nao-encontrada/pagina-nao-encontrada.component";
import { NfsePayloadService } from "./nfse/nfse-payload/nfse-payload.service";
import { UrlSerializer } from "@angular/router";
import { LowerCaseUrlSerializer } from "./compartilhado/Util/LowerCaseUrlSerializer";
import { VisualizarLaudoModule } from "./laudos-pa/visualizar-laudo/modules/visualizar-laudo.module";
import { VisualizarImagemOriginalModule } from "./laudos-pa/visualizar-imagem-original/modules/visualizar-imagem-original.module";

@NgModule({
  declarations: [
    AppComponent,
    PopUpAlertaComponent,
    PaginaNaoEncontradaComponent,
  ],
  imports: [
    HttpClientModule,
    BrowserModule,
    CompartilhadoModule,
    CoreModule,
    BrowserAnimationsModule,
    ScrollEventModule,
    DxDateBoxModule,
    AppRoutingModule,
    DxSelectBoxModule,
    VisualizarLaudoModule,
    VisualizarImagemOriginalModule,
    NgxMaskModule.forRoot(),
    LocalStorageModule.forRoot({
      prefix: "VistoriaGerencial",
      storageType: "localStorage",
    }),
  ],
  providers: [
    DatePipe,
    AutenticacaoService,
    AgendamentoService,
    AgendamentoMTService,
    OwsClientService,
    PopUpService,
    RequestsService,
    NfsePayloadService,
    AppConfigProvider,
    VisualizarImagemOriginalService,
    SessionService,
    AuthGuard,
    InterceptorService,
    LoaderService,
    PagamentoService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: PageTopComponent,
      multi: true,
    },
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: "6Ld3PRwUAAAAAInDv3PZ17YEXk3bE9llTZzQEYEd",
      } as RecaptchaSettings,
    },
    {
      provide: UrlSerializer,
      useClass: LowerCaseUrlSerializer,
    },
    GlobalService,
    SelectivePreloadingStrategy,
    AppConfigService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
